import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { ValueTickFormatter } from 'src/utils/TickFormatters';
import { useRoiDef } from 'src/utils/calculateRoi';
import { useAggregationLevelContext } from '../../contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from '../../hooks/useGetDateAxisFormatter';
import { getAggregateLevelData } from '../../utils/getAggregateLevelData';
import { TimeseriesDataTableModal } from '../molecules/TimeseriesDataTableModal';

const title = 'ROI';

export const ROIBox: React.FC = () => {
  const { roi } = useMMDataContext();
  const { aggregateLevel } = useAggregationLevelContext();
  const roiDef = useRoiDef();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return getAggregateLevelData(roi, aggregateLevel);
  }, [roi, aggregateLevel]);

  const xAxisFormatter = useGetDateAxisFormatter();

  return (
    <KeyMetricGraphBox
      title={title}
      data={data}
      xAxisFormatter={xAxisFormatter}
      yAxisFormatter={ValueTickFormatter}
      isError={roi.isError}
      isLoading={roi.isLoading}
      infoHeader="Return on Investment"
      infoText={roiDef}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={ValueTickFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
